import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class OtDetailsService {
    private headers = new Headers({'Content-Type': 'application/json'});
    private AddRecord = webapi + 'trn_ot_procedure_details/create';
    private AddByOpsIdRecord = webapi + 'trn_ot_procedure_details/createbyopsid';
    private GetRecord = webapi + 'trn_ot_procedure_details/byid/';
    private UpdateRecord = webapi + 'trn_ot_procedure_details/updateotddetails/';


    constructor(private http: Http) {
    }

    addRecordService(model: any) {
        // console.log(JSON.stringify(model));
        return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addByOpsIdRecordService(model: any) {
        // console.log(JSON.stringify(model));
        return this.http.post(this.AddByOpsIdRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordService(id: any) {
        return this.http.get(this.GetRecord + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    updateotdDetails(opdId: any, otHours: any, otStartDate: any, otStartTime: any, otEndStart: any, otEndTime: any ) {
        return this.http.get(this.UpdateRecord +  opdId + '/' + otHours + '/' + otStartDate + '/' + otStartTime + '/' + otEndStart + '/' + otEndTime)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    // updateotdDetails(opdId: any, otHours: any, otStartDate: any, otStartTime: any, otEndStart: any, otEndTime: any ) {
    //     return this.http.get(this.updateDetailsRecord +  opdId + '/' + otHours + '/' + otStartDate + '/' + otStartTime + '/' + otEndStart + '/' + otEndTime)
    //         .toPromise()
    //         .then(response => response.json())
    //         .catch(this.handleError);
    // }
    //
    // updateotdChecklist(opdId: any, model: any) {
    //     return this.http.post(this.updateChecklistRecord + 'opdId=' + opdId, JSON.stringify(model), {headers: this.headers})
    //         .toPromise()
    //         .then(response => response.json())
    //         .catch(this.handleError);
    // }
    //
    // updateotdProcedureConsent(opdId: any, model: any) {
    //     return this.http.post(this.updateProcedureConsentRecord + 'opdId=' + opdId, JSON.stringify(model), {headers: this.headers})
    //         .toPromise()
    //         .then(response => response.json())
    //         .catch(this.handleError);
    // }
    //
    // updateotdProcedureItem(opdId: any, model: any) {
    //     return this.http.post(this.updateProcedureItemRecord + 'opdId=' + opdId, JSON.stringify(model), {headers: this.headers})
    //         .toPromise()
    //         .then(response => response.json())
    //         .catch(this.handleError);
    // }
    //
    // updateOpdProcedurePreOperativeInstruction(opdId: any, model: any) {
    //     return this.http.post(this.updateProcedurePreOperativeInstructionRecord + 'opdId=' + opdId, JSON.stringify(model), {headers: this.headers})
    //         .toPromise()
    //         .then(response => response.json())
    //         .catch(this.handleError);
    // }
    //
    // updateOpdProcedureIntraOperativeInstruction(opdId: any, model: any) {
    //     return this.http.post(this.updateProcedureIntraOperativeInstructionRecord + 'opdId=' + opdId, JSON.stringify(model), {headers: this.headers})
    //         .toPromise()
    //         .then(response => response.json())
    //         .catch(this.handleError);
    // }
    //
    // updateOpdProcedurePostOperativeInstruction(opdId: any, model: any) {
    //     return this.http.post(this.updateProcedurePostOperativeInstructionRecord + 'opdId=' + opdId, JSON.stringify(model), {headers: this.headers})
    //         .toPromise()
    //         .then(response => response.json())
    //         .catch(this.handleError);
    // }
    //
    // updateOpdProcedureDoctor(opdId: any, model: any) {
    //     return this.http.post(this.updateProcedureDoctorRecord + 'opdId=' + opdId, JSON.stringify(model), {headers: this.headers})
    //         .toPromise()
    //         .then(response => response.json())
    //         .catch(this.handleError);
    // }
    //
    // updateOpdProcedureStaff(opdId: any, model: any) {
    //     return this.http.post(this.updateProcedureStaffRecord + 'opdId=' + opdId, JSON.stringify(model), {headers: this.headers})
    //         .toPromise()
    //         .then(response => response.json())
    //         .catch(this.handleError);
    // }
    //
    // updateOpdProcedureService(opdId: any, model: any) {
    //     return this.http.post(this.updateProcedureServiceRecord + 'opdId=' + opdId, JSON.stringify(model), {headers: this.headers})
    //         .toPromise()
    //         .then(response => response.json())
    //         .catch(this.handleError);
    // }


    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/operation-theater/ot-details/ot-details.service.ts